var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"under-header padding-bottom",attrs:{"id":"rules"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"panel large"},[_c('div',{staticClass:"text-centered"},[_c('img',{staticStyle:{"width":"80%"},attrs:{"src":"/assets/img/mapas.jpg","alt":"map"}})])])])])
}]

export { render, staticRenderFns }